module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/138-bahrain-ef672594cee4358c5c92c63ab9dc768f.svg";